;(function(angular) {
    'use strict';

    angular
        .module('fauzanKhanQueryBuilder')
        .factory('QBTemplatesFactory', ['$compile', 'QB_CONSTANTS', function($compile, QB_CONSTANTS) {

            //Returns templates for sub query popover, operation popover and add more button
            var getTemplates = function(currIndex) {
                currIndex = parseInt(currIndex);
                var templates = {};
                templates.addMoreBtn = '<span class="new-entry-btn" ng-click="newEntry($event)" data-curr-index="<%currIndex}}"><span class="plus-icon">+</span></span>';
                templates.operator = '<div class="operator-wrapper popover-parent" data-operator-id="' + currIndex + '">' +
                    '<span class="operator query-builder-label neutral" ng-click="togglePopover($event)">AND</span>' +
                    '<div class="operator-popover query-popover">' +
                    '<div class="popover-body">' +
                    '<span class="triangle"></span>' +
                    '<span ng-repeat="jointOperator in options.jointOperators" class="operator-option" ng-click="changeOperator(jointOperator, $event)" ng-bind="jointOperator"></span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'+\', $event)">+</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'-\', $event)">-</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'*\', $event)">*</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'/\', $event)">/</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'AND\', $event)">AND</span>' +
                    // '<span class="operator-option" ng-click="changeOperator(\'OR\', $event)">OR</span>' +
                    '<span class="operator-option add-bracket" ng-click="addBrackets($event)" ng-hide="query.bracketIds.indexOf(' + currIndex + ') > -1">(brackets)</span>' +
                    '<span class="operator-option remove-bracket" ng-if="options.showBrackets" ng-show="query.bracketIds.indexOf(' + currIndex + ') > -1" ng-click="removeBrackets($event)"><strike>(brackets)</strike></span>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                templates.operandSelection = '<div class="operand-selection popover-parent" data-opererand-id="' + currIndex + '">' +
                    '<span class="query-builder-btn query-builder-btn-dropdown query-text" ng-click="togglePopover($event)">' +
                    '<span ng-if="query.operands[' + currIndex + '].column || query.operands[' + currIndex + '].custom">' +
                    '<%query.operands[' + currIndex + '].column.label+" "+query.operands[' + currIndex + '].operation+" "+query.operands[' + currIndex + '].value+""+query.operands[' + currIndex + '].custom%>'+
                    '</span>' +
                    '<span ng-hide="query.operands[' + currIndex + '].column || query.operands[' + currIndex + '].custom">Enter Query</span>' +
                    '</span>' +
                    '<div class="operand-popover query-popover">' +
                    '<div class="operand-popover-content">' +
                    '<span class="triangle"></span>' +
                    '<div class="popover-header" ng-if="options.allowCustomQuery">' +
                    '<div class="heading">' +
                    '<span>Query Type</span>' +
                    '</div>' +
                    '<div class="query-types">' +
                    '<div class="query-type">' +
                    '<input type="radio" name="query-type-' + currIndex + '" id="query-type-' + currIndex + '-basic" value="basic" ng-model="query.operands[' + currIndex + '].type" ng-change="changeQueryType(' + currIndex + ',\'basic\' )"/>' +
                    '<label for="query-type-' + currIndex + '-basic">Basic</label>' +
                    '</div>' +
                    '<div class="query-type">' +
                    '<input type="radio" name="query-type-' + currIndex + '" id="query-type-' + currIndex + '-custom" value="custom" ng-model="query.operands[' + currIndex + '].type" ng-change="changeQueryType(' + currIndex + ',\'custom\' )"/>' +
                    '<label for="query-type-' + currIndex + '-custom">Custom</label>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="popover-body">' +
                    '<div ng-show="query.operands[' + currIndex + '].type==\'basic\'">' +
                    '<div class="col-name-wrapper">' +
                    '<label>Select Column</label>' +
                    '<select ng-model="query.operands[' + currIndex + '].column" ng-options="col as col.label for col in columns" ng-change="columns"></select>'+
                    '</div>' +
                    '<div class="operation-wrapper" ng-if="options.mode === ' + QB_CONSTANTS.FILTER_MODE + '">' +
                    '<label>Select Operation</label>' +
                    '<select ng-model="query.operands[' + currIndex + '].operation" ng-options="valueOperator for valueOperator in options.valueOperators">'+
                    '</select>' +
                    '</div>' +
                    '<div class="value-wrapper" ng-if="options.mode === ' + QB_CONSTANTS.FILTER_MODE + '">' +
                    '<label>Value</label>' +
                    '<input type="text" ng-model="query.operands[' + currIndex + '].value" />' +
                    '</div>' +
                    '</div>' +
                    '<div ng-show="query.operands[' + currIndex + '].type==\'custom\'">' +
                    '<textarea ng-model="query.operands[' + currIndex + '].custom" plaveholder="Enter custom sub query"></textarea>' +
                    '</div>' +
                    '<div class="done-btn-wrapper">' +
                    '<button class="query-builder-btn small no-margins" ng-click="togglePopover($event)">Done</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                return templates;
            };

            //Builds/Prepopulate query in DOM in case scope.data is present
            var buildTemplate = function(ele, expression, operands, bracketIds, scope) {
                var bracketCount = 0;
                var expArray = expression.split(/((?:\(|\)|[A-Z]+|\d+))/g);
                var currOperand = 0;
                var expressionArray = expArray.filter(function(e) {
                    return e != '';
                })
                for (var i = 0; i < expressionArray.length; i++) {
                    var temp = expressionArray[i];
                    var template = getTemplates(i);
                    if (temp == '(') {
                        var bracketId = bracketIds[bracketCount];
                        var leftBracket = '<span class="bracket opening-bracket" data-bracket-id="' + bracketId + '">(</span>';
                        ele.find('.query-builder-wrapper').append(leftBracket);
                        bracketCount += 1;
                    } else if (temp == ')') {
                        var bracketId = bracketIds[bracketCount];
                        var rightBracket = '<span class="bracket closing-bracket" data-bracket-id="' + bracketId + '">)</span>';
                        ele.find('.query-builder-wrapper').append(rightBracket);
                        bracketCount += 1;
                    } else if (temp == 'AND' || temp == 'OR') {
                        var template = getTemplates(parseInt(currOperand));
                        ele.find('.query-builder-wrapper').append($compile(template.operator)(scope));
                    } else if (!isNaN(temp)) {
                        var template = getTemplates(parseInt(temp));
                        ele.find('.query-builder-wrapper').append($compile(template.operandSelection)(scope));
                        currOperand = parseInt(currOperand);
                        currOperand += 1;
                    }
                }
            };
            return {
                get: getTemplates,
                build: buildTemplate
            }
        }])
})(angular);